import { ApiEpShorturl } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "shorturl.providers";

type Response = Await<ReturnType<typeof ApiEpShorturl.Backend.list>>;

export const useQueryShorturlProviderSet = (
  options?: Omit<UseQueryOptions<Response>, "queryKey" | "queryFn">,
) => useQuery<Response>([KEY], ApiEpShorturl.Backend.list, options);

useQueryShorturlProviderSet.KEY = KEY;
